// extracted by mini-css-extract-plugin
module.exports = {"recordingBtn":"recordingBtn___3skD5","icon":"icon___b1yGD","disable":"disable___15B7C"};